module Meevo.Components.Common {
    interface IYextService {
        getURL: (section: string) => void;
    }

    export class YextService implements IYextService {
        public url: string = undefined;
        public isLocationOnboarded: boolean;

        constructor(
            private appSettings: Meevo.Components.Common.IAppSettings,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private busyService: Meevo.Components.Busy.IBusyService,
            private modalService: Meevo.Components.Modal.IModalService
        ) { }

        public getURL(section: string, nav: string = 'true'): ng.IPromise<void> {
            this.busyService.start();

            return this.dataService.customMethodData(`${this.appSettings.API_ROOT}/Yext/LocationYextSSOData/${this.appSettings.APP_BUSINFOSETTINGS.locationId}`, 'GET', null).then((res) => {
                this.busyService.stop();
                this.isLocationOnboarded = res.data.isLocationSuccessfullyOnboarded;

                this.url = `${res.data.yextApiUrl}/users/corplogin?` +
                    `accountid=${res.data.accountid}` +
                    `&code=${res.data.code}` +
                    `&timestamp=${res.data.timestamp}` +
                    `&sign=${res.data.sign}` +
                    `&embed=${nav}` + // nav: true, false, nosubnav
                    `&nav=${section}`;
            });
        }

        public showWarningLocationNotOnboarded(): ng.IPromise<any> {
            return this.modalService.alert('WARNING_LOCATION_NOT_ONBOARDED');
        }

        static factory(): Function {
            let svc = (appSettings, dataService, busyService, modalService) => {
                return new YextService(appSettings, dataService, busyService, modalService);
            }

            svc.$inject = [
                'meevo.AppSettings',
                'meevo.components.common.DataService',
                'meevo.components.busy.BusyService',
                'meevo.components.modal.ModalService'
            ];

            return svc;
        }
    }
    angular.module('meevo.components.common')
        .factory('meevo.components.common.YextService', YextService.factory());
}
